<template>
  <div class="wrapper">
    <div class="look-nav">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="look-nav-center">物料详情</div>
      <div class="handle-wrapper" @click="saveData"><div class="icon-font">&#xec11;</div>编辑</div>
    </div>
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="material-detail" style="display: block" v-if="!loading">
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">物料编号：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.code" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin" style="width: 49.33%">
          <div class="input-title">烟叶简称：</div>
          <div class="input-wrapper" style="flex: 1">
            <input v-model="inputValue.name" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">建档时间：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.createdTime" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-title">基本属性</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 1.78vw">产地：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.placeOfOrigin" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">类型：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.type" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">品种：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.variety" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">购销分类：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.purchaseAndSaleClassification" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">企业等级：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.enterpriseLevel" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">形态：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.shape" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 0.83vw">生产线：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.productLine" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">箱号：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.cartonNumber" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 1.78vw">毛重：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.roughWeight" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">净重：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.netWeight" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">生产日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.productionDate" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 0.83vw">批次号：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.accountBatch" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 1.78vw">年份：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.year" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-title">物料详情</div>
      <div class="material-detail-item">01.基本信息</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">基地信息：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.blii" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">原烟调拨：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.originalSmokeTransfer" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">主摘品种：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.mainPickVariety" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">平均海拔：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.averageAltitude" placeholder=""/>
            <div class="input-suffix">（米）</div>
          </div>
        </div>
      </div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">轮作比例：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.rotationRatio" placeholder=""/>
            <div class="input-suffix">（%）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">平均温度：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.avgTemp" placeholder=""/>
            <div class="input-suffix">（℃）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">地形地貌：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.topography" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">育苗方式：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.breedMethod" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">打顶留叶：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.toppingLeaves" placeholder=""/>
            <div class="input-suffix">（片）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">采烤时间：</div>
          <div class="input-suffix-wrapper">
            <el-date-picker
              v-model="inputValue.pickingBakingTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="material-detail-item">02.调拨信息</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 1.78vw">年份：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.yearOfTransfer" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">数量：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.transferQuantity" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
      </div>
      <div class="material-detail-item">03.加工信息</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 0.89vw">加工厂：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.processingPlant" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 0.89vw">加工量：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.processingVolume" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 0.89vw">产出量：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.processingOutput" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 0.89vw">出片率：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.processingRate" placeholder=""/>
            <div class="input-suffix">（%）</div>
          </div>
        </div>
      </div>
      <div class="material-detail-item">04.库存信息</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">储存仓库：</div>
          <LoadingTreeStack :moduleType="moduleType"  :content="inputValue.siteName" :editCheckId="inputValue.siteId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">数量：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.stockQuantity" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">箱数：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.stockBox" placeholder=""/>
            <div class="input-suffix">（箱）</div>
          </div>
        </div>
      </div>
      <div class="material-detail-item">05.生产信息</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title">库存信息：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.produceStockInfo" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">数量：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.produceQuantity" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">箱数：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.produceBox" placeholder=""/>
            <div class="input-suffix">（箱）</div>
          </div>
        </div>
      </div>
      <div class="material-detail-title">业务台账</div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 1.78vw">日期：</div>
          <div class="input-wrapper">
            <el-date-picker
              v-model="inputValue.accountDate"
              type="date"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">业务类型：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.businessType" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">仓库：</div>
          <LoadingTreeStack :moduleType="moduleType"  :content="inputValue.accountSiteName" :editCheckId="inputValue.accountSiteId" v-on:sendInfo = "showDropAccount"></LoadingTreeStack>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 0.89vw">仓库员：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.accountWarehousemen" placeholder=""/>
          </div>
        </div>
      </div>
      <div class="material-detail-list">
        <div class="input-contain">
          <div class="input-title" style="padding-left: 1.78vw">数量：</div>
          <div class="input-suffix-wrapper">
            <input v-model="inputValue.accountQuantity" placeholder=""/>
            <div class="input-suffix">（担）</div>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title" style="padding-left: 1.78vw">品名：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.accountProductName" placeholder=""/>
          </div>
        </div>
        <div class="input-contain add-margin">
          <div class="input-title">质检情况：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.qualityInspection" placeholder=""/>
          </div>
        </div>
      </div>
    </div>
    <img class="wrapper-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import {materialDetail, materialUpdate} from '../../../api/basic'
import {renderTime, changeTime} from '../../../tools/methods'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
export default {
  name: 'MaterialDetail',
  components: { LoadingTreeStack },
  data () {
    return {
      loading: true,
      moduleType: '00',
      inputValue: {
        createdTime: '',
        accountBatch: '',
        accountDate: '',
        accountProductName: '',
        accountQuantity: '',
        accountSiteId: '',
        accountSiteName: '',
        accountSiteType: '',
        accountWarehousemen: '',
        averageAltitude: '',
        avgTemp: '',
        blii: '',
        breedMethod: '',
        businessType: '',
        code: '',
        enterpriseLevel: '',
        id: '',
        mainPickVariety: '',
        name: '',
        originalSmokeTransfer: '',
        pickingBakingTime: '',
        placeOfOrigin: '',
        processingOutput: '',
        processingPlant: '',
        processingRate: '',
        processingVolume: '',
        purchaseAndSaleClassification: '',
        qualityInspection: '',
        rotationRatio: '',
        shape: '',
        siteId: '',
        siteName: '',
        siteType: '',
        stockBox: '',
        stockQuantity: '',
        topography: '',
        toppingLeaves: '',
        transferQuantity: '',
        type: '',
        variety: '',
        yearOfTransfer: '',
        produceBox: '',
        produceQuantity: '',
        produceStockInfo: ''
      }
    }
  },
  created () {
    let body = {
      pkId: this.$route.query.pkId
    }
    materialDetail(body).then(res => {
      console.log(res)
      res.data.createdTime = renderTime(res.data.createdTime || '')
      res.data.productionDate = changeTime(res.data.productionDate || '')
      res.data.year = changeTime(res.data.year || '')
      this.inputValue = res.data
      this.inputValue.accountSiteName = res.data.accountSiteName || ''
      this.inputValue.siteName = res.data.siteName || ''
      this.loading = false
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    showDropInfo: function (data) {
      console.log(data)
      this.inputValue.siteName = data.gatherSite
      this.inputValue.siteId = data.id
      this.inputValue.siteType = data.siteType
    },
    showDropAccount: function (data) {
      console.log(data)
      this.inputValue.accountSiteName = data.gatherSite
      this.inputValue.accountSiteId = data.id
      this.inputValue.accountSiteType = data.siteType
    },
    saveData: function () {
      console.log(this.inputValue)
      materialUpdate(this.inputValue).then(res => {
        console.log(res)
        this.$message({
          message: res.data,
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
@import "./Material.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/material/MaterialDetail.vue